module.exports = __webpack_public_path__ + "img/warn-header.70578be0.png";